import { Typography } from 'antd'
import { TextProps } from 'antd/lib/typography/Text'
import { CSSProperties, FC } from 'react'

import Styles from './Text.module.scss'

export type format =
    | 't12'
    | 't16'
    | 't14'
    | 't18'
    | 't20'
    | 't24'
    | 't28'
    | 't32'
    | 't40'
    | 't56'
    | 'tab'

interface Props extends TextProps {
    format?: format
    style?: CSSProperties
    content?: any
    color?: string
    bold?: boolean
    semiBold?: boolean
    noWrap?: boolean
    lineHeight?: number
    letterSpacing?: number
    display?: string
    textAlign?: 'left' | 'center' | 'right'
    onClick?: () => void
    deletedText?: boolean
    noUnderline?: boolean
    textTransform?: 'capitalize' | 'uppercase' | 'lowercase'
}

const { Text } = Typography
export const BitazzaText: FC<Props> = ({
    format,
    deletedText,
    content,
    color,
    lineHeight,
    letterSpacing,
    bold,
    noWrap,
    display,
    textAlign,
    onClick,
    semiBold,
    style,
    noUnderline,
    textTransform,
    ...props
}) => {
    const mainClasses = []

    switch (format) {
        case 't12':
            mainClasses.push(Styles.t12)
            break
        case 't16':
            mainClasses.push(Styles.t16)
            break
        case 't18':
            mainClasses.push(Styles.t18)
            break
        case 't20':
            mainClasses.push(Styles.t20)
            break
        case 't24':
            mainClasses.push(Styles.t24)
            break
        case 't28':
            mainClasses.push(Styles.t28)
            break
        case 't32':
            mainClasses.push(Styles.t32)
            break
        case 't40':
            mainClasses.push(Styles.t40)
            break
        case 't56':
            mainClasses.push(Styles.t56)
            break
        case 'tab':
            mainClasses.push(Styles.tab)
            break
        default:
            mainClasses.push(Styles.t14)
    }
    return (
        <Text
            delete={deletedText}
            onClick={onClick}
            {...props}
            className={mainClasses.join(' ')}
            style={{
                color: color && color,
                lineHeight: lineHeight ? `${lineHeight}px` : '23px',
                letterSpacing: letterSpacing ? `${letterSpacing}px` : 'default',
                fontWeight: semiBold ? '500' : bold ? `700` : 'initial',
                whiteSpace: noWrap ? 'nowrap' : 'normal',
                display: display ? display : 'inline-block',
                textAlign: textAlign ? textAlign : 'initial',
                textDecoration: onClick && !noUnderline ? 'underline' : 'none',
                float: textAlign ? (textAlign as any) : 'none',
                textTransform: textTransform ? textTransform : 'unset',
                ...style,
            }}
        >
            {content}
        </Text>
    )
}
